import API from "../config/api.js";

export const StoreService ={

    getBranches() {
    
        return API.get("/api/inventory/branches");
      },

      createStore(formData){
        return API.post("/api/store/create",formData);
      },
      getStores(search, page){
        return API.get(`/api/store/list/se=${search}`, {params: {page: page}});
      },
      async getStoreById(id) {
        try {
          const response = await API.get(`/api/store/info/${id}`);
          return response.data.data; // Return the specific batch details
        } catch (error) {
          console.error("Error fetching Batch details:", error);
          throw error;
        }
      },
      async  updateStore(formData,id){
        console.log('formData :', formData);

        try {
           
            const response = await API.put(`/api/store/info/update/${id}`, formData);
            console.log('Response from API:', response);
            if (response.status === 200) {
              return response.data;
            } else {
              throw new Error('Unexpected response status: ' + response.status);
            }
          } catch (error) {
                console.error('Error updating Store:', error);
            if (error.response) {
              console.error('API Response Error:', error.response.data);
            }
            throw error;
          }
    },

    deleteStore(id) {
        return API.delete(`/api/store/${id}`);
      },

}